import Box from "@material-ui/core/esm/Box";
import PriorityHigh from "@material-ui/icons/esm/PriorityHigh";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { EnumInvoiceStatus } from 'api';
import { getUnpaidInvoicesForCustomer, getUnpaidInvoicesRequestIdState } from 'api/invoices/getUnpaidInvoicesForCustomer';
import BadgeStep from 'components/BadgeStep/BadgeStep';
import { SecondaryButton } from 'components/Button';
import InfoBox from 'components/InfoBox/InfoBox';
import Spinner from 'components/Spinner/Spinner';
import { Header } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import { INVOICES } from 'routes/invoices/paths';
import checkLoadable from 'utils/recoil/checkLoadable';
import useStyles from './OverviewStyles';
export default function Overview() {
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  const {
    customer
  } = useCurrentCustomer();
  const {
    unpaidInvoicesStyling,
    infoText
  } = useStyles();
  const loadableUnpaidInvoices = useRecoilValueLoadable(getUnpaidInvoicesForCustomer(customer?.id));
  const setRequestState = useSetRecoilState(getUnpaidInvoicesRequestIdState);
  const {
    contents: unpaidInvoices,
    loading
  } = checkLoadable(loadableUnpaidInvoices);
  const unpaidInvoicesCount = unpaidInvoices?.totalResults || 0;
  const frozenStatus = unpaidInvoices?.results?.find(element => element.invoiceStatus === EnumInvoiceStatus.ExternalDebtCollection);
  useEffect(() => {
    setRequestState(prev => prev + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Header, null, t('invoices.invoices')), loading && /*#__PURE__*/React.createElement(Spinner, null), !loading && unpaidInvoices && unpaidInvoicesCount > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BadgeStep, {
    className: unpaidInvoicesStyling,
    badgeContent: /*#__PURE__*/React.createElement(PriorityHigh, {
      fontSize: "small"
    })
  }, `${t('invoices.you_have_number_of', {
    invoicesCount: unpaidInvoicesCount
  })} ${unpaidInvoicesCount === 1 ? t('invoices.unpaid_invoice') : t('invoices.unpaid_invoices').toLowerCase()}`), frozenStatus && /*#__PURE__*/React.createElement(InfoBox, {
    warning: true,
    mb: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: infoText
  }, /*#__PURE__*/React.createElement("span", null, t('invoices.debt_collection_warning_start'), ' ', t('invoices.debt_collection_warning_middle'), ' ', t('invoices.debt_collection_warning_end')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, t('invoices.debt_collection_contact')))), /*#__PURE__*/React.createElement(SecondaryButton, {
    onClick: () => push(INVOICES)
  }, /*#__PURE__*/React.createElement("span", null, t('invoices.show_unpaid_invoices')))), !loading && unpaidInvoicesCount === 0 && t('invoices.no_unpaid'));
}